// extracted by mini-css-extract-plugin
var _1 = "RequestProfileHeaderFooterAddNewText-moduleRequestProfileHeaderFooterAddNewText__fnNHw";
export { _1 as "RequestProfileHeaderFooterAddNewText" }
